













import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import { BottomTabbar } from '@/components';
import { appShare, wxShareInfo } from '@/common/ts/common';
import * as config from './config';
@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  bannerSrc = require('./assets/banner.jpg');
  option = config.OPTHINES;
  created() {
    this.$addPv(361);
    const baseUrl =
      'https://activity.cqcb.com/shangyou_activity/2019q3/2019LJFL';

    const shareUrl =
      window.location.href.indexOf('/detail?') > -1
        ? window.location.href
        : `${baseUrl}/givelike`;
    appShare({
      title: '重庆市垃圾分类时尚小区暨最美社区游园',
      url: shareUrl,
      subtitle: '重庆市垃圾分类时尚小区暨最美社区游园',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      classId: -1,
      id: -1,
      type: 3,
    });
    wxShareInfo({
      title: '重庆市垃圾分类时尚小区暨最美社区游园',
      subtitle: '重庆市垃圾分类时尚小区暨最美社区游园',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
